export type CardConfigDataType = {
  imageKey: string;
  linkKey?: string;
  action?: () => {};
};

export type CardConfigType = {
  HAS_PC: CardConfigDataType;
  NO_PC: {
    UPSELL_ELIGIBLE: CardConfigDataType;
    NOT_UPSELL_ELIGIBLE: CardConfigDataType;
  };
  PROMO: CardConfigDataType;
};

export const CARD_CONFIG: CardConfigType = {
  HAS_PC: {
    imageKey: 'groupClassCard.hasPC.image',
    linkKey: 'groupClassCard.hasPC.link'
  },
  NO_PC: {
    UPSELL_ELIGIBLE: {
      imageKey: 'groupClassCard.noPC.upsellEligible.image', 
    },
    NOT_UPSELL_ELIGIBLE: {
      imageKey: 'groupClassCard.noPC.notUpsellEligible.image', 
      linkKey: 'groupClassCard.noPC.notUpsellEligible.link'
    }
  },
  PROMO: {
    imageKey: 'groupClassCard.promo.image',
    linkKey: 'groupClassCard.promo.link'
  }
};

export enum Breakpoints {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  EXTRA_LARGE= 'extraLarge'
}

export const BREAKPOINT_MAP = {
  [Breakpoints.SMALL]: 0,
  [Breakpoints.MEDIUM]: 768,
  [Breakpoints.LARGE]: 992,
  [Breakpoints.EXTRA_LARGE]: 1200
};


// WEBPACK FOOTER //
// ./ts/app/home/live-class-revamp/group-class/gc-card-setup.ts